import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';
import { BibItem, Item } from '../../providers/item/item';
import { AppState } from '../../config/state';

@Injectable()
export class IlsProvider {
  constructor(private api: ApiProvider, private state: AppState) {
  }
  async getSearchTypes() {
    const query = `{
      ilsSearchTypes {
        name
        type
        default
      }
    }`
    let response = await this.api.query(query);
    if(!response || !response.ilsSearchTypes) return null;
    response.ilsSearchTypes.sort((a, b) => {
      return a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'});
    })
    return response.ilsSearchTypes
  }
  async getSearchFilters() {
    const query = `{
      ilsSearchFilters {
        name
        value
      }
    }`
    let response = await this.api.query(query);
    if(!response || !response.ilsSearchFilters) return null;
    return response.ilsSearchFilters;
  }
  async getSortTypes() {
    const query = `{
      ilsSearchSortTypes {
        name
        type
        default
      }
    }`
    let response = await this.api.query(query);
    if(!response || !response.ilsSearchSortTypes) return null;
    return response.ilsSearchSortTypes;
  }
  async searchCatalog(term: string, start: number, limit: number, type: string, sort?: string, filter?: string): Promise<CatalogResults> {
    let params = `term:"${term}" `;
    if (start) {
      params += ` start: ${start} `;
    }
    if (limit) {
      params += ` limit: ${limit} `;
    }
    if (type) {
      params += ` type: "${type}" `;
    }
    if (sort) {
      params += ` sort: "${sort}" `
    }
    if (filter) {
      params += ` filter: "${filter}" `
    }
    console.log(params);
    const query = `{
      ilsSearchCatalog(${params}){
        term total start limit results {
          id
          ids { type id }
          title
          author
          authors
          callNumber
          publisher
          publishYear
          pageCount
          averageRating
          ratingsCount
          source
          readingModes { text image }
          available
          format
          formatDetails {
            code
            icon
            name
            virtual
          }
          language
          previewLink
          imageLinks { type url }
          isbns
          upcs
          subjects
          summaries { text source }
          series
          notes
        }
      }
    }`;
    let response = await this.api.query(query);
    return response && response.ilsSearchCatalog ? response.ilsSearchCatalog : null;
  };
  async getBibDetailsFromBarcode(barcode: string): Promise<BibItem> {
    const query = `{
      ilsGetBibDetails(barcode:"${barcode}"){
        id
        ids { type id }
        title
        author
        authors
        publisher
        publishYear
        pageCount
        averageRating
        ratingsCount
        readingModes { text image }
        available
        format
        formatDetails {
          code
          icon
          name
          virtual
        }
        language
        previewLink
        imageLinks { type url }
        isbns
        upcs
        subjects
        summaries { text source }
        series
        notes
        source
        holdable,
        callNumber
      }
    }`;
    let response = await this.api.query(query);
    return response && response.ilsGetBibDetails ? response.ilsGetBibDetails : null;
  };
  async getBibDetailsFromId(bibId: string): Promise<BibItem> {
	  if(this.state.demo){
		  switch (bibId){
			case '11290494': return {"id":11290494,"ids":[{"type":"ISBN","id":"9781594488405"},{"type":"LCCN","id":"2017031394"},{"type":"MARC","id":"sky289377230"}],"title":"The female persuasion","author":"Wolitzer, Meg, author.","authors":["Wolitzer, Meg,"],"publisher":null,"publishYear":2018,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":true,"format":"BOOK","language":null,"previewLink":null,"imageLinks":null,"isbns":["9781594488405"],"upcs":[],"subjects":["Ambition","Fiction.","Interpersonal relations","Feminists"],"summaries":[{"text":"Greer Kadetsky is a shy college freshman when she meets the woman she hopes will change her life. Faith Frank, dazzlingly persuasive and elegant at sixty-three, has been a central pillar of the women's movement for decades, a figure who inspires others to influence the world. Upon hearing Faith speak for the first time, Greer- madly in love with her boyfriend, Cory, but still full of longing for an ambition that she can't quite place- feels her inner world light up. And then, astonishingly, Faith invites Greer to make something out of that sense of purpose, leading Greer down the most exciting path of her life as it winds toward and away from her meant-to-be love story with Cory and the future she'd always imagined","source":null}],"series":[],"notes":[]};
			case '11290430': return {"id":11290430,"ids":[{"type":"ISBN","id":"9780062436634"},{"type":"LCCN","id":"2018001821"},{"type":"MARC","id":"sky291576427"}],"title":"To die but once","author":"Winspear, Jacqueline, 1955- author.","authors":["Winspear, Jacqueline,"],"publisher":null,"publishYear":2018,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":true,"format":"BOOK","language":null,"previewLink":null,"imageLinks":null,"isbns":["9780062436634"],"upcs":[],"subjects":["Dobbs, Maisie","(Fictitious character)","Fiction.","Missing persons","Detective and mystery fiction.","lcgft","Historical fiction."],"summaries":[{"text":"Spring 1940. With Britons facing what has become known as \"the Bore War\"—nothing much seems to have happened yet—Maisie Dobbs is asked to investigate the disappearance of a local lad, a young apprentice craftsman working on a \"hush-hush\" government contract. As Maisie’s inquiry reveals a possible link to the London underworld, another mother is worried about a missing son—but this time the boy in question is one beloved by Maisie.","source":null}],"series":["A Maisie Dobbs novel"],"notes":[]};
			case '11314873': return {"id":11314873,"ids":[{"type":"CallNumber","id":"158.1"},{"type":"ISBN","id":"9781501182464"},{"type":"LCCN","id":"bl2018001138"},{"type":"MARC","id":"sky291634622"},{"type":"NBN","id":"GBB828996"}],"title":"This messy magnificent life : a field guide","author":"Roth, Geneen, author.","authors":["Roth, Geneen,"],"publisher":null,"publishYear":2018,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":true,"format":"BOOK","language":null,"previewLink":null,"imageLinks":null,"isbns":["9781501182464"],"upcs":[],"subjects":["Self-realization in women.","Self-acceptance."],"summaries":[{"text":"Inspiring, personal, and often spiritual reflections on how women can find peace, make wise choices, practice everyday joy, and step into their power from Geneen Roth—author of the #1 New York Times bestselling Women Food and God.  From the beginning, Geneen Roth was told she was too sensitive, too emotional, too curious, too demanding, too intense, and too big. Yet gaining and losing weight for decades did not improve her self-worth or reduce other people’s criticisms. Like most women who struggle with their weight, she believed that if she could resolve what seemed to be the source of her self-hatred—how and what she ate—she would be thin, happy, and free. That belief, she discovered, was false.  When her struggle with food ended—and didn’t change anything except the size of her thighs—she kept trying to fix other broken parts of herself with therapy, intensive meditation retreats, and rigorous spiritual practices. Yet it was only when Geneen stopped trying to change or fix herself—that she was at last able to feel at home in her mind, body, and life. Now, she shares the wisdom of giving up what Geneen calls \"the Me Project,\" and finding the freedom, peace and power that await us just beyond it.  With humor, compassion, and insight, This Messy Magnificent Life explores the personal beliefs, hidden traumas, and social pressures that shape not just women’s feelings about their bodies, but also their confidence, choices, and relationships. This provocative, enchanting, and sometimes laugh-out-loud look at the imperfect path women take to step into their own power, presence, and ownership is based on the author’s personal journey and her decades of work with thousands of women around the country.  Roth embraces everyone’s unique and often unsung potential and shows us how to be open, curious, and kind with ourselves; how to say no to people and ideas that hold us back; how to let go of grudges and anxieties; how to pick ourselves up after setbacks; how to say a resounding yes to the world; how to move from fixing ourselves to finding ourselves; how to find joy in the ordinary; and how to experience the extraordinary right here and now in our bodies.  With a foreword by Anne Lamott, This Messy Magnificent Life is a compelling and often quirky look at what it means to be an imperfect but unapologetic woman living a (mostly) magnificent life.","source":null}],"series":[],"notes":[]};
			case '11326029': return {"id":11326029,"ids":[{"type":"ISBN","id":"9780062819833"},{"type":"LCCN","id":"2017042257"},{"type":"MARC","id":"sky290369393"},{"type":"NBN","id":"GBB845001"}],"title":"The other mother : a novel","author":"Goodman, Carol, author.","authors":["Goodman, Carol,"],"publisher":null,"publishYear":2018,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":true,"format":"BOOK","language":null,"previewLink":null,"imageLinks":null,"isbns":["9780062819833"],"upcs":[],"subjects":["Mothers and daughters","Fiction.","Motherhood","Psychological fiction.","lcgft","Thrillers (Fiction)"],"summaries":[{"text":"\"From the author of the internationally bestselling The Lake of Dead Languages comes a gripping novel about madness, motherhood, love, and trust. When Daphne Marist and her infant daughter, Chloe, pull up the gravel drive to the home of Daphne's new employer, it feels like they've entered a whole new world. Tucked in the Catskills, the stone mansion looks like something out of a fairy tale, its lush landscaping hiding the view of the mental asylum just beyond its border. Daphne secured the live-in position using an assumed name and fake credentials, telling no one that she's on the run from a controlling husband who has threatened to take her daughter away. Daphne's new life is a far cry from the one she had in Westchester where, just months before, she and her husband welcomed little Chloe. From the start, Daphne tries to be a good mother, but she's plagued by dark moods and intrusive thoughts that convince her she's capable of harming her own daughter. When Daphne is diagnosed with Post Partum Mood Disorder, her downward spiral feels unstoppable--until she meets Laurel Hobbes.  Laurel, who also has a daughter named Chloe, is everything Daphne isn't: charismatic, sophisticated, fearless. They immediately form an intense friendship, revealing secrets to one another they thought they'd never share. Soon, they start to look alike, dress alike, and talk alike, their lives mirroring one another in strange and disturbing ways. But Daphne realizes only too late that being friends with Laurel will come at a very shocking price--one that will ultimately lead her to that towering mansion in the Catskills where terrifying, long-hidden truths will finally be revealed....\"--","source":"Provided by publisher."}],"series":[],"notes":[]};
			case '11290445': return {"id":11290445,"ids":[{"type":"ISBN","id":"9780399176623"},{"type":"LCCN","id":"2018002724"},{"type":"MARC","id":"sky289241942"}],"title":"The disappeared","author":"Box, C. J., author.","authors":["Box, C. J.,"],"publisher":null,"publishYear":2018,"pageCount":null,"averageRating":null,"ratingsCount":null,"readingModes":null,"available":true,"format":"BOOK","language":null,"previewLink":null,"imageLinks":null,"isbns":["9780399176623"],"upcs":[],"subjects":["Pickett, Joe","(Fictitious character)","Fiction.","Game wardens","Wyoming","Missing persons","Investigation","Detective and mystery fiction.","lcgft","Thrillers (Fiction)"],"summaries":[{"text":"\"Wyoming game warden Joe Pickett has two lethal cases to contend with in the electrifying new novel from #1 New York Times-bestselling author C. J. Box.  Wyoming's new governor isn't sure what to make of Joe Pickett, but he has a job for him that is extremely delicate. A prominent female British executive never came home from the high-end guest ranch she was visiting, and the British Embassy is pressing hard. Pickett knows that happens sometimes--these ranches are stocked with handsome young cowboys, and \"ranch romances\" aren't uncommon. But no sign of her months after she vanished?  That suggests something else.  At the same time, his friend Nate Romanowski has asked Joe to intervene with the feds on behalf of falconers who can no longer hunt with eagles even though their permits are in order.  Who is blocking the falconers and why?   The more he investigates both cases, the more someone wants him to go away. Is it because of the missing woman or because he's become Nate's advocate? Or are they somehow connected? The answers, when they come, will be even worse than he'd imagined\"--","source":"Provided by publisher."}],"series":["A Joe Pickett novel ;"],"notes":[]}
		  }
	  }
    const query = `{
      ilsGetBibDetails(bibid:"${bibId}"){
        id
        ids { type id }
        title
        author
        authors
        publisher
        publishYear
        pageCount
        averageRating
        ratingsCount
        readingModes { text image }
        available
        format
        formatDetails {
          code
          icon
          name
          virtual
        }
        language
        previewLink
        imageLinks { type url }
        isbns
        upcs
        subjects
        summaries { text source }
        series
        notes
        source
        holdable,
        callNumber
      }
	}`;
	let response = await this.api.query(query);
    return response && response.ilsGetBibDetails ? response.ilsGetBibDetails : null;
  };

  async getItemFromBarcode(barcode: string): Promise<Item> {
    const query = `{
      ilsGetItem(barcode:"${barcode}"){
        id
        checkoutOk
        statusText
        statusCode
        bibIds
        barcode
        dueDate
        cost
        location {
          code
          name
        }
        bib{
          id
          ids { type id }
          title
          author
          authors
          publisher
          publishYear
          pageCount
          averageRating
          ratingsCount
          readingModes { text image }
          available
          format
          formatDetails {
            code
            icon
            name
            virtual
          }
          language
          previewLink
          imageLinks { type url }
          isbns
          upcs
          subjects
          summaries { text source }
          series
          notes
          source
          holdable
        }
      }
    }`;
    let response = await this.api.query(query);
    return response && response.ilsGetItem ? response.ilsGetItem : null;
  };
  async getItemFromId(itemId: string): Promise<Item> {
    const query = `{
      ilsGetItem(itemid:"${itemId}"){
        id
        checkoutOk
        statusText
        statusCode
        bibIds
        barcode
        dueDate
        location {
          code
          name
        }
        bib{
          id
          ids { type id }
          title
          author
          authors
          publisher
          publishYear
          pageCount
          averageRating
          ratingsCount
          readingModes { text image }
          available
          format
          formatDetails {
            code
            icon
            name
            virtual
          }
          language
          previewLink
          imageLinks { type url }
          isbns
          upcs
          subjects
          summaries { text source }
          series
          notes
          source
          holdable
        }
      }
    }`;
    let response = await this.api.query(query);
    return response && response.ilsGetItem ? response.ilsGetItem : null;
  };

  async apiCheckoutBook(barcode: string, book: string, branchId: string, pin: string): Promise<any> {
	const query = `mutation{
		sip2CheckoutItem(itemBarcode:"${book}" patronBarcode:"${barcode}" branchId:"${branchId}" patronPin:"${pin}") {
		  status
		  dueDate
		  message
			item {
			itemIdentifier
			  titleIdentifier
			  mediaType
			  itemProperties
			checkoutOk
			screenMessage
			}
		}
	  }`
	  let response = await this.api.query(query);
	  // console.log('response', response);
	  return response && response.sip2CheckoutItem ? response.sip2CheckoutItem : null;
	  // let response;
	  // response = {status: true, code: barcode, book: book, dueDate: "2018-07-02"};
	  // return response;
  }

  sip2DirectCheckoutBook(barcode: string, book: string, branchId: string, pin: string): Promise<any> {
	return window.Bridge.coSip2.checkoutItem(book, branchId, barcode, pin);
  }


  checkoutBook(barcode: string, book: string, branchId: string, pin: string): Promise<any> {
	if(this.state.directSip2 && window.Bridge.coSip2){
		console.log(`checking out ${book} for ${barcode} done via sip2`);
		return this.sip2DirectCheckoutBook(barcode, book, branchId, pin);
	}else{
		console.log(`checking out ${book} for ${barcode} done via api`);
		return this.apiCheckoutBook(barcode, book, branchId, pin);
	}
  }

  async checkinBook(book: string, branchId: string): Promise<any> {
	const query = `mutation{
		sip2CheckIn(itemBarcode:"${book}" branchId:"${branchId}"){
			status
      message
      item {
        itemIdentifier
        titleIdentifier
        mediaType
        itemProperties
        checkoutOk
        screenMessage
      }
		}
		}`
		let response = await this.api.query(query);
		// console.log('response', response.sip2CheckoutItem);
		return response && response.sip2CheckIn ? response.sip2CheckIn : null;
  }

  async renewBook(book: string, patron: any, pin?: any): Promise<any> {
    const query = `
    mutation{
      ilsRenewCheckout(checkoutId:"${book}" barcode:"${patron}" pin:"${pin}"){
        status
        dueDate
        message
      }
    }`
    let response = await this.api.query(query);
    return response && response.ilsRenewCheckout ? response.ilsRenewCheckout : null;
  }

  async renewBookSip2(book: string, patron: any, pin?: any, branchId?: any): Promise<any> {
	if(this.state.directSip2 && window.Bridge.coSip2){
		console.log(`Renew of ${book} for ${patron} done via sip2`);
		return window.Bridge.coSip2.renewItem(book, patron, pin);
	}else{
		console.log(`Renew of ${book} for ${patron} done via api`);
		return this.apiRenewBookSip2(book, patron, pin, branchId);
	}
  }
  async apiRenewBookSip2(book: string, patron: any, pin?: any, branchId?: any): Promise<any> {
    const query = `
    mutation{
      sip2Renew(patronBarcode:"${patron}" patronPin:"${pin}" itemBarcode:"${book}" branchId:"${branchId}") {
        status
        message
        dueDate
      }
    }`
    let response = await this.api.query(query);
    return response && response.sip2Renew ? response.sip2Renew : null;
  }

  async renewAllSip2(patron: any, pin: any, branchId?: any): Promise<any> {
	if(this.state.directSip2 && window.Bridge.coSip2){
		console.log(`Renew all for ${patron} done via sip2`);
		return window.Bridge.coSip2.renewAllItems(patron, pin);
	}else{
		console.log(`Renew all for ${patron} done via api`);
		return this.apiRenewAllSip2(patron, pin, branchId);
	}

  }
  async apiRenewAllSip2(patron: any, pin: any, branchId?: any): Promise<any> {
    const query = `
    mutation{
      sip2RenewAll(patronBarcode:"${patron}" patronPin:"${pin}" branchId:"${branchId}"){
        status message renewedCount unrenewedCount renewedItems unrenewedItems
      }
    }`
    let response = await this.api.query(query);
    return response && response.sip2RenewAll ? response.sip2RenewAll : null;
  }

  async getBibHoldingInfo(bibId: string) {
    const query = `
    {
      ilsGetBibHoldings(bibid: "${bibId}") {
        id
        checkoutOk
        statusText
        statusCode
        bibIds
        barcode
        dueDate
        callNumber
        location {
          code
          name
          locationID
          position {
            latitude
            longitude
          }
        }
      }
    }`
    let response = await this.api.query(query);
    if(!response || !response.ilsGetBibHoldings)return null;
    response.ilsGetBibHoldings.map(res =>{
      if (!res.location) return res.location = {name: 'In transit', code: null};
    });
    response.ilsGetBibHoldings.sort((a,b)=>{
      // return (a.location.name < b.location.name)? -1 : (a.location.name > b.location.name)? 1 : 0;
      return a.location.name.localeCompare(b.location.name, undefined, {numeric: true, sensitivity: 'base'});
    })
    return response.ilsGetBibHoldings;
  }

  async placeHold(patronBarcode: string, patronPin: string, bibId: string, pickupCode: string, recordType?: string) {
    const query = `
    mutation{
      ilsPlaceHold(barcode: "${patronBarcode}" pin: "${patronPin}" recordId:"${bibId}" recordType:"${recordType}" pickupCode:"${pickupCode}"){
        status
        message
      }
    }`

    let response = await this.api.query(query);
    return response && response.ilsPlaceHold ? response.ilsPlaceHold : null;
  }

  async cancelHold(barcode, holdId, pin?) {
    const query = `
    mutation{
      ilsCancelHold(holdtId:"${holdId}" barcode: "${barcode}" pin: "${pin}") {
        status
        message
      }
    }`

    let response = await this.api.query(query);
    return response && response.ilsCancelHold ? response.ilsCancelHold : null;
  }

  async freezeHold(barcode, pin, holdId){
    const query = `
      mutation{
        ilsFreezeHold(holdtId: "${holdId}" barcode: "${barcode}" pin: "${pin}") {
          status
          message
        }
      }
    `
    let response = await this.api.query(query);
    return response && response.ilsFreezeHold ? response.ilsFreezeHold : null;
  }

  async unfreezeHold(barcode, pin, holdId){
    const query = `
      mutation{
        ilsUnfreezeHold(holdtId: "${holdId}" barcode: "${barcode}" pin: "${pin}") {
          status
          message
        }
      }
    `
    let response = await this.api.query(query);
    return response && response.ilsUnfreezeHold ? response.ilsUnfreezeHold : null;
  }

  async getPickupLocations(): Promise<Array<Item>> {
    if (!this.state.pickupLocations) {
      const query = `
      {
        ilsPickupLocations {
          code
          name
          position {
            latitude
            longitude
          }
        }
      }`

      let response = await this.api.query(query);
      if(!response || !response.ilsPickupLocations)return null;
      if (response.ilsPickupLocations) {
        response.ilsPickupLocations.sort((a, b) => {
          return (a.name < b.name) ? -1 : (a.name > b.name) ? 1 : 0;
        });
      }
      this.state.pickupLocations = (response && response.ilsPickupLocations) ? response.ilsPickupLocations : null;
    }
    return this.state.pickupLocations;
  }

}
export interface CatalogResults {
  term: string;
  total: number;
  start: number;
  limit: number;
  results: Array<BibItem>;
}


// WEBPACK FOOTER //
// ./src/providers/ils/ils.ts